export const SET_PURCHASE_DATA = "SET_PURCHASE_DATA";
export const PURCHASE_SESSION_FETCHING_INIT = "PURCHASE_SESSION_FETCHING_INIT";
export const PURCHASE_REGNS_FETCHING_INIT = "PURCHASE_REGNS_FETCHING_INIT";
export const PURCHASE_SUMMARY_PLANS_FETCHING_INIT =
  "PURCHASE_SUMMARY_PLANS_FETCHING_INIT";
export const DATA_FETCH_INIT = "DATA_FETCH_INIT";
